import { create } from 'zustand'

const useTheme = create((set) => ({
  dark: localStorage.getItem('tradescope-theme') === 'dark',
  toggle: () => set((state) => {
    const next = !state.dark
    localStorage.setItem('tradescope-theme', next ? 'dark' : 'light')
    if (next) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
    return { dark: next }
  }),
  init: () => {
    const stored = localStorage.getItem('tradescope-theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const isDark = stored === 'dark' || (!stored && prefersDark)
    if (isDark) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
    set({ dark: isDark })
  }
}))

export default useTheme
